import React from 'react';
import {UploadDataPoint} from "../_section/DataPointForm";

function DataForm({upload, inExtWindow, setMortgage}) {
    return (
        <>
            <UploadDataPoint setMortgage={setMortgage} name="startDate" upload={upload} inExtWindow={inExtWindow}/>
            <UploadDataPoint setMortgage={setMortgage} name="documentDate" upload={upload} inExtWindow={inExtWindow}/>
            <UploadDataPoint setMortgage={setMortgage} name="accountNumber" upload={upload} inExtWindow={inExtWindow}/>
            <UploadDataPoint setMortgage={setMortgage} name="creditLimit" upload={upload} inExtWindow={inExtWindow}/>
            <UploadDataPoint setMortgage={setMortgage} name="outstandingBalance" upload={upload} inExtWindow={inExtWindow}/>
        </>
    );
}


export default DataForm;